/** @format */

import useResetPasswordMailHooks from "../../hooks/useResetPasswordMailHooks";
import { ResetPasswordMailElement } from "../../components/ui_elements";
import { Container } from "../../components/layouts/Container";
import { ErrorHandler } from "../../api/ErrorHandler";
import { initApiModelType } from "../../constance/typeModel";
import useNavigateByAgent from "../../hooks/useNavigateByAgentHooks";

const ResetPasswordMail = () => {
  const { navigateByAgent } = useNavigateByAgent();
  const { sendEmail, setEmailHandler, EmailData, ErrMsg, normal, abnormal } = useResetPasswordMailHooks();
  const { ErrorHandle } = ErrorHandler(navigateByAgent);

  //エラーハンドリング実行
  const sendEmailHandler = async () => {
    const response = await sendEmail(EmailData);
    ErrorHandle<initApiModelType<undefined>>(response, normal, abnormal, true);
  };

  return (
    <Container>
      <ResetPasswordMailElement setEmailHandler={setEmailHandler} sendEmailHandler={sendEmailHandler} ErrMsg={ErrMsg} />
    </Container>
  );
};

export default ResetPasswordMail;
